/**
 * Created by Reda on 05.07.2026
 */

cleverapps.SkinManager.SKINS.rapunzel3_expedition = {
    bundle: "expedition_rapunzel3",

    slots: {
        ...cleverapps.SkinManager.SKINS.rose_energy.slots,
        workerCutTime: function () {
            return 500;
        },

        miningEffects: function () {
            return {
                animation: "chop",
                effect: "mining.worker.rapunzel3"
            };
        },

        workerMiningAnimationStyles: function () {
            return cleverapps.styles.rapunzel3.miningAnimation;
        },

        gameAudio: function () {
            return bundles.expedition_rapunzel3.urls.rapunzel3_music;
        },

        gameSceneBg: function () {
            return {
                movableAnimation: bundles.expedition_rapunzel3.jsons.rapunzel3_bg,
                parallax: {
                    hideHorizon: true
                }
            };
        },

        outOfBoundaryScale: function () {
            return 0;
        },

        noPoiFog: function (unit) {
            if (unit) {
                const code = unit.head ? unit.head.code : unit.code;
                return ["rpcustomerbridge0", "rpcustomerbridge1", "rpcustomerbridge2"].includes(code);
            }
        },

        fogBlocker: function () {
            return cleverapps.styles.FogLockView.expedition;
        },

        worker_json: bundles.merge_rapunzel3.jsons.worker_json,

        whirlwind: bundles.fog_animations.jsons.rapunzel3_whirlwind,

        expedition_buildpass_icon_json: bundles.sidebar.jsons.rapunzel3_expedition_buildpass_icon_json,

        fog_disappear_effect: function () {
            return bundles.fog_rapunzel3.urls.open_effect;
        }
    }
};
